import Generator from '../../../Generator'
import Types from '../../../../actions/Types'

export default Generator.node({
  baseType: Types.COLORS,
  nodeType: Generator.NODETYPE.LIST
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/colors/list.js